// Cart Service to manage the shopping cart activities locally with session persistence

const CART_KEY = 'shopping_cart';

// Fetch all items currently in the cart
export const getCartItems = () => {
    const data = localStorage.getItem(CART_KEY);
    return data ? JSON.parse(data) : [];
};

// Add an item to the cart
export const addToCart = (product, weight, message) => {
    let items = getCartItems();
    const w = product.weight || weight || '500 gm';
    const m = product.message || message || '';
    
    const existingIndex = items.findIndex(item => item.name === product.name && item.weight === w);
    
    if (existingIndex !== -1) {
        items[existingIndex].quantity += 1;
    } else {
        items.push({
            ...product,
            weight: w,
            message: m,
            quantity: 1,
            addedAt: new Date().toISOString()
        });
    }
    
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    
    // Dispatch a custom event to notify components that the cart has been updated
    window.dispatchEvent(new CustomEvent('cartUpdated', { detail: { count: getTotalItemsCount() } }));
    return items;
};

// Calculate the total number of items in the cart
export const getTotalItemsCount = () => {
    const items = getCartItems();
    return items.reduce((total, item) => total + item.quantity, 0);
};

// Remove an item from the cart
export const removeFromCart = (index) => {
    let items = getCartItems();
    items.splice(index, 1);
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('cartUpdated', { detail: { count: getTotalItemsCount() } }));
    return items;
};

// Update quantity of an item
export const updateQuantity = (index, delta) => {
    let items = getCartItems();
    items[index].quantity += delta;
    
    if (items[index].quantity <= 0) {
        items.splice(index, 1);
    }
    
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('cartUpdated', { detail: { count: getTotalItemsCount() } }));
    return items;
};

// Clear the entire cart
export const clearCart = () => {
    localStorage.removeItem(CART_KEY);
    window.dispatchEvent(new CustomEvent('cartUpdated', { detail: { count: 0 } }));
};
